export var DealerStatus;
(function (DealerStatus) {
    DealerStatus["PENDING"] = "Pending";
    DealerStatus["APPROVED"] = "Approved";
    DealerStatus["REJECTED"] = "Rejected";
    DealerStatus["TEMPORARY"] = "temporary";
})(DealerStatus || (DealerStatus = {}));
const ifNotEmpty = (address) => Object.values(address).some(value => value !== null && value !== 0) ? address : null;
const transformMainAddress = ({ title, street, number, streetAddition, city, zip, region, firstName, lastName, gender, company, phoneMain, phoneMobile, fax, ustIdNr, country, commercialRegister, commercialRegisterNumber, authorizedRepresentative }) => ({
    title,
    street,
    number,
    streetAddition,
    city,
    zip,
    region,
    firstName,
    lastName,
    gender,
    company,
    phoneMain,
    phoneMobile,
    fax,
    ustIdNr,
    commercialRegister,
    commercialRegisterNumber,
    authorizedRepresentative,
    country: !country ? null : country.id
});
const transformContactAddress = ({ title, firstName, lastName, gender, phoneMain, phoneMobile, email }) => ({
    title,
    firstName,
    lastName,
    gender,
    phoneMain,
    phoneMobile,
    email
});
const transformBillingAddress = ({ title, street, number, streetAddition, city, zip, region, firstName, lastName, gender, company, email, country }) => ({
    title,
    street,
    number,
    streetAddition,
    city,
    zip,
    region,
    firstName,
    lastName,
    gender,
    company,
    email,
    country: !country ? null : country.id
});
export const transform = ({ email, website, emailPermission, dealerType, emailVerified, paymentAccount, mainAddress, contactAddress, billingAddress, businessAddress, imprint, termCond, legacyApiPartner }) => ({
    email,
    website,
    paymentAccount,
    emailPermission,
    legacyApiPartner,
    mainAddress: mainAddress ? ifNotEmpty(transformMainAddress(mainAddress)) : null,
    contactAddress: contactAddress ? ifNotEmpty(transformContactAddress(contactAddress)) : null,
    billingAddress: billingAddress ? ifNotEmpty(transformBillingAddress(billingAddress)) : null,
    businessAddress: businessAddress ? ifNotEmpty(transformBillingAddress(businessAddress)) : null,
    imprint: {
        de: imprint && imprint.de
    },
    termCond: {
        de: termCond && termCond.de
    }
});
